import axios from 'axios';
import { useCallback, useEffect, useRef, useState } from 'react';
import { ClientsSummaryProps, CLientSummaryProps, DateStatusProps } from '../schema/clients';
import { apiUrl } from '../App';
import { useFetchData } from './ApiManager';
import { ENDPOINTS } from './EndPoints';

export const useGetClient = (id: string) => {
  const fetch = id !== '';
  const { apiData, isPending, errorMessage } = useFetchData(
    ENDPOINTS.GET_CLIENT(id),
    fetch
  );
  const clientId = apiData?.client_id;
  const clientName = apiData?.client_name;
  return { clientId, clientName, isPending, errorMessage };
};

export const useGetClients = () => {
  const { apiData, isPending, errorMessage } = useFetchData(
    ENDPOINTS.GET_CLIENTS
  );
  const clientsList = apiData?.clients_list.map((client: any) => ({
    label: client.client_name,
    value: client.client_id,
  }));
  return { clientsList, isPending, errorMessage };
};

export const useGetClientsSummary: () => ClientsSummaryProps = () => {
  const { apiData, isPending, errorMessage } = useFetchData(
    ENDPOINTS.GET_CLIENTS_SUMMARY
  );
  const clientsSummary: CLientSummaryProps[] =
    apiData?.clients_summary || ([] as CLientSummaryProps[]);

  return { clientsSummary, isPending, errorMessage };
};

export const useClientDateStatus = (clientId: string) => {
  const [dateStatus, setDateStatus] = useState<DateStatusProps | null>(null);
  const [isDateStatusPending, setIsDateStatusPending] = useState(false);
  const [fetchTrigger, setFetchTrigger] = useState(0);
  const tokenRef = useRef(localStorage.getItem('token'));

  const refetchDateStatus = useCallback(() => {
    setFetchTrigger((t) => t + 1);
  }, []);

  useEffect(() => {
    if (!clientId) return;
    setIsDateStatusPending(true);
    axios
      .get(`${apiUrl}/api${ENDPOINTS.GET_CLIENT_DATE_STATUS(clientId)}`, {
        headers: { Authorization: tokenRef.current },
      })
      .then((res) => {
        setDateStatus(res.data as DateStatusProps);
        setIsDateStatusPending(false);
      })
      .catch(() => {
        setIsDateStatusPending(false);
      });
  }, [clientId, fetchTrigger]);

  return { dateStatus, isDateStatusPending, refetchDateStatus };
};
